var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect } from 'react';
import styled from '@emotion/styled';
import { size } from 'polished';
import { display, alignItems, position, top, space, justifyContent, backgroundColor, boxShadow, fontSize, width, border, } from 'styled-system';
import { themeHeight } from '../../common/theme/theme';
import Drawer from '../../common/components/Drawer';
import RichTextBlock from '../../common/components/RichText';
import Icon from '../../common/components/Icon';
import SwipeListener from '../../common/components/SwipeListener';
import { DisclaimerSubscription } from '../../common/event-bus/EventSubscription';
import { useLocalization } from '../../common/providers/LocaleProvider';
import EventBus from '../../common/event-bus/EventBus';
import { EventBusEvent } from '../../common/enums/EventBus';
import { KeyCode } from '../../common/enums/Keyboard';
var eventBus = new EventBus();
var ICON_SIZE = 18;
var Header = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  cursor: pointer;\n  outline: none;\n  z-index: 1;\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  cursor: pointer;\n  outline: none;\n  z-index: 1;\n"])), display, alignItems, position, top, space, fontSize, themeHeight, width, justifyContent, backgroundColor, boxShadow, border);
Header.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    position: 'fixed',
    top: 0,
    px: ['sp_16', 'sp_24', null, 'sp_32'],
    py: 0,
    fontSize: ['fs_16', null, null, 'fs_18'],
    themeHeight: ['54px', 'sp_64'],
    width: 1,
    justifyContent: 'left',
    backgroundColor: 'white',
    boxShadow: 'bottom',
    border: 'none',
};
var Arrow = styled(Icon)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n"])), size(ICON_SIZE + "px"), space);
Arrow.defaultProps = {
    name: 'arrowLeft',
    mr: 'sp_4',
};
var Content = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), space);
Content.defaultProps = {
    mt: ['54px', 'sp_64'],
};
var StyledRichTextBlock = styled(RichTextBlock)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  p {\n    ", ";\n  }\n"], ["\n  ", ";\n  p {\n    ", ";\n  }\n"])), space, fontSize);
StyledRichTextBlock.defaultProps = {
    p: ['sp_16', 'sp_24', null, 'sp_32'],
    fontSize: ['fs_14', null, 'fs_16', 'fs_18'],
};
var CLOSE_DISCLAIMER_EVENT = {
    open: false,
    lockScroll: false,
};
var CommonDisclaimer = function () {
    var t = useLocalization().t;
    useEffect(function () {
        var keyDownHandler = function (event) {
            if (event.keyCode === KeyCode.Escape) {
                closeDrawer();
            }
        };
        document.addEventListener('keydown', keyDownHandler);
        return function () {
            document.removeEventListener('keydown', keyDownHandler);
        };
    }, []);
    var closeDrawer = useCallback(function () {
        eventBus.emit(EventBusEvent.ToggleDisclaimer, __assign({}, CLOSE_DISCLAIMER_EVENT));
    }, []);
    return (React.createElement(DisclaimerSubscription, null, function (_a) {
        var value = _a.value;
        return (React.createElement(SwipeListener, { onSwipeRight: closeDrawer },
            React.createElement(Drawer, { isOpen: value.open, onBackdropClick: closeDrawer },
                value.open && (React.createElement(Header, { onClick: closeDrawer },
                    React.createElement(Arrow, null),
                    t('h24_go_back'))),
                React.createElement(Content, null, value.content || (React.createElement(StyledRichTextBlock, { p: value.p, dangerouslySetInnerHTML: { __html: value.html }, "data-testid": "html" }))))));
    }));
};
export default CommonDisclaimer;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
